import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type { CandidateCertificate } from '../types/certificate.types';

export const certificateService = {
  async getByShareId(shareId: string): Promise<CandidateCertificate> {
    const response = await apiClient<ApiResponse<CandidateCertificate>>(
      `/public/candidates/${shareId}/certificate`,
      { method: 'GET' }
    );
    return response.data;
  },
};
